import React from 'react';
import PropTypes from 'prop-types';
import { FallingLines } from 'react-loader-spinner';
import './css/ForgotPasswordForm.css';
import { requestPasswordReset } from '../../../Utils/RestUtils';
import { emailValidation } from '../../../Utils/ValidationUtil';
import {
  INCORRECT_EMAIL_FORMAT,
  SYSTEM_FAULT,
  FORGOT_PASSWORD_TITLE,
  FORGOT_PASSWORD_TEXT,
  FORGOT_PASSWORD_SEND,
  FORGOT_PASSWORD_SENT_TITLE,
  FORGOT_PASSWORD_SENT_TEXT,
  BACK_TO_LOGIN,
} from '../../../Utils/Constants/GlobalConstants';

class ForgotPasswordForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      emailValue: '',
      emailWasFocused: false,
      isEmailValid: false,
      errorMessage: '',
      isSubmitSpinnerVisible: false,
      isSent: false,
    };
  }

  handleEmailChange = (e) => {
    const { emailWasFocused } = this.state;
    const emailValue = e.target.value;
    const isEmailValid = emailValidation(emailValue);

    this.setState({ emailValue, isEmailValid });

    if (emailWasFocused) {
      this.setState({
        errorMessage: isEmailValid ? '' : INCORRECT_EMAIL_FORMAT,
      });
    }
  };

  handleEmailInputBlur = () => {
    const { emailValue, isEmailValid } = this.state;

    if (emailValue.length > 0) {
      this.setState({
        emailWasFocused: true,
        errorMessage: isEmailValid ? '' : INCORRECT_EMAIL_FORMAT,
      });
    }
  };

  handleSubmit = (e) => {
    e.preventDefault();

    const { emailValue, isEmailValid, isSubmitSpinnerVisible } = this.state;

    if (!isEmailValid || isSubmitSpinnerVisible) {
      return;
    }

    this.setState({ isSubmitSpinnerVisible: true, errorMessage: '' });

    requestPasswordReset({ email: emailValue })
      .then((response) => {
        if (response && response.data === 'success') {
          this.setState({ isSent: true });
        } else {
          this.setState({ errorMessage: SYSTEM_FAULT });
        }
      })
      .catch(() => {
        this.setState({ errorMessage: SYSTEM_FAULT });
      })
      .finally(() => {
        this.setState({ isSubmitSpinnerVisible: false });
      });
  };

  renderBackButton = () => {
    const { showLoginForm } = this.props;

    return (
      <div className="login_show_reg">
        <button
          type="button"
          className="blue_link login_register"
          onClick={showLoginForm}
        >
          {BACK_TO_LOGIN}
        </button>
      </div>
    );
  };

  renderSent = () => {
    const { emailValue } = this.state;

    return (
      <div className="login_form_w">
        <div className="bm_text_24 login_title">
          {FORGOT_PASSWORD_SENT_TITLE}
        </div>
        <div className="fpf_text gr_text_16 mb_30">
          {`${FORGOT_PASSWORD_SENT_TEXT} ${emailValue}`}
        </div>
        {this.renderBackButton()}
      </div>
    );
  };

  render() {
    const {
      emailValue,
      emailWasFocused,
      isEmailValid,
      errorMessage,
      isSubmitSpinnerVisible,
      isSent,
    } = this.state;

    if (isSent) {
      return this.renderSent();
    }

    return (
      <form className="login_form_w" onSubmit={this.handleSubmit}>
        <div className="bm_text_24 login_title">{FORGOT_PASSWORD_TITLE}</div>
        <div className="fpf_text gr_text_16 mb_20">{FORGOT_PASSWORD_TEXT}</div>
        <input
          value={emailValue}
          className={`login_form_input ${
            !isEmailValid && emailWasFocused ? 'logon_ivalid_input' : ''
          }`}
          onChange={this.handleEmailChange}
          onBlur={this.handleEmailInputBlur}
          placeholder="Email"
          type="email"
          autoComplete="email"
        />

        <div className="login_button_w">
          <button
            type="submit"
            className={`login_button ${
              isEmailValid ? 'blue_button login_btn_active' : 'login_btn_dis'
            }`}
            disabled={!isEmailValid || isSubmitSpinnerVisible}
          >
            <div className="login_button_content">
              {FORGOT_PASSWORD_SEND}
              <div className="login-falling-loading">
                <FallingLines
                  color="#ffffff"
                  width="30"
                  visible={isSubmitSpinnerVisible}
                />
              </div>
            </div>
          </button>
          <div className="login_form_message rr_text_14">{errorMessage}</div>
        </div>

        {this.renderBackButton()}
      </form>
    );
  }
}

ForgotPasswordForm.propTypes = {
  showLoginForm: PropTypes.func.isRequired,
};

export default ForgotPasswordForm;
